<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    d="M1.57 21.966h20.86M22.43 9.45H1.57M16.172 6.67l-3.06-4.08a1.39 1.39 0 0 0-2.225 0L7.828 6.67M7.828 19.184v-6.953M7.828 12.23h.695a2.086 2.086 0 0 1 0 4.173h-.695M3.656 12.232a1.39 1.39 0 0 0-1.39 1.39v4.172a1.39 1.39 0 0 0 2.78 0v-4.172a1.39 1.39 0 0 0-1.39-1.39ZM16.172 19.184h-1.39a1.391 1.391 0 0 1-1.391-1.39V13.62a1.39 1.39 0 0 1 1.39-1.39h1.39M13.39 16.403h2.782M18.953 19.184v-6.953l2.781 6.953v-6.953"
  /></svg>
</template>
